module.exports = __webpack_public_path__ + "c8c08e5df573c1881e8e9a8350984846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/date-icon.svg
// module id = 1098
// module chunks = 0